export default __webpack_public_path__ + "516b5ecf2049b767459de7c56ee7582f.png";